import { createFileRoute } from "@tanstack/react-router";
import AppOnlyPage from "@/components/AppOnlyPage";

export const Route = createFileRoute("/_default/shop")({
  component: RouteComponent,
});

function RouteComponent() {
  return <AppOnlyPage />;
}
